import * as React from 'react';
import { ShareFb, ShareInstagram, ShareVk, ShareYoutube } from '../../ui/icon/icons/share-socials';

const styles = require('./socials.css');

const socialsData: { url: string; icon: React.ReactNode }[] = [
  {
    icon: <ShareFb className={styles['fb']} />,
    url: 'https://www.facebook.com/pikofficial/?fref=ts',
  },
  {
    icon: <ShareVk className={styles['vk']} />,
    url: 'https://vk.com/pikru',
  },
  {
    icon: <ShareInstagram className={styles['instagram']} />,
    url: 'https://www.instagram.com/pik/',
  },
  {
    icon: <ShareYoutube className={styles['youtube']} />,
    url: 'https://www.youtube.com/channel/UClOYT0q47Qyzz1r1KJIIZDw',
  },
];

export class Socials extends React.PureComponent<object, object> {
  public render() {
    return (
      <ul className={styles['list']}>
        {socialsData.map(social => (
          <li className={styles['list-item']} key={social.url}>
            <a href={social.url} target="_blank" rel="noreferrer" className={styles['share-link']}>
              {social.icon}
            </a>
          </li>
        ))}
      </ul>
    );
  }
}
